import { render, staticRenderFns } from "./OrderRequirements.vue?vue&type=template&id=ff8a90d2&scoped=true"
import script from "./OrderRequirements.vue?vue&type=script&lang=js"
export * from "./OrderRequirements.vue?vue&type=script&lang=js"
import style0 from "./OrderRequirements.vue?vue&type=style&index=0&id=ff8a90d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8a90d2",
  null
  
)

export default component.exports